export const TAX_RATES = [
  { value: '0.255', text: '25.5%' },
  { value: '0.25', text: '25%' },
  { value: '0.21', text: '21%' },
  { value: '0.20', text: '20%' },
  { value: '0.19', text: '19%' },
  { value: '0.16', text: '16%' },
  { value: '0.15', text: '15%' },
  { value: '0.12', text: '12%' },
  { value: '0.10', text: '10%' },
  { value: '0.09', text: '9%' },
  { value: '0.085', text: '8.5%' },
  { value: '0.081', text: '8.1%' },
  { value: '0.07', text: '7%' },
  { value: '0.077', text: '7.7%' },
  { value: '0.055', text: '5.5%' },
  { value: '0.05', text: '5%' },
  { value: '0.026', text: '2.6%' },
  { value: '0.025', text: '2.5%' },
  { value: '0.021', text: '2.1%' },
  { value: '0', text: '0%' },
  { value: '-1', text: 'default' },
];
